import FilterPagesGeneral from "../../components/FilterPagesGeneral";

export default function Quotes() {
  const filterMethods = ["student_name", "status"];

  return (
    <FilterPagesGeneral pageName={"quotes"} filterMethods={filterMethods} />
  );
}
